import React from 'react';
import { Icon } from 'semantic-ui-react';
import { ErrorSC, ErrorMsg } from './ErrorMessage.style';
import { useTranslation } from 'react-i18next';
import { P } from 'utils/resuable-css';

const ErrorMessage = ({ text, style, textStyles }) => {
  const { t } = useTranslation();
  return (
    <ErrorSC style={style}>
      <Icon name="warning circle" />
      <ErrorMsg>
        <P style={textStyles}>{t(text || 'choose_one_option')}</P>
      </ErrorMsg>
    </ErrorSC>
  );
};

export default ErrorMessage;
